Vue.filter('decimals', function (value, nDecimals) {
    if (!value) return '';

    nDecimals = typeof nDecimals !== 'undefined' ? nDecimals : 3;
    return parseFloat(value).toFixed(nDecimals);
});

Vue.filter('formatPrice', function(value, nDecimals) {
    if (!value) return '';

    nDecimals = typeof nDecimals !== 'undefined' ? nDecimals : 3;
    return parseFloat(value).toFixed(decimals);
});

Vue.filter('formatCurrency', function(value, currency) {
    if (!value) return '';

    const euros = Intl.NumberFormat('es-ES', {
        style: 'currency',
        currency: 'EUR',
        maximumSignificantDigits: 3,
    });

    return euros.format(value);
});

Vue.filter('formatVariation', function(value, nDecimals) {
    if (value === null) return '';

    var sign = '';
    if (value > 0) { sign = '+'; }
    else if (value < 0) { sign = ''; }

    nDecimals = typeof nDecimals !== 'undefined' ? nDecimals : 3;
    return sign + value.toFixed(nDecimals);
});

Vue.filter('formatDate', function (value, format) {
    if (!value) return '';

    // Maybe the date comes with time mark too
    if (value.indexOf(' ') >= 0) {
        value = value.split(' ')[0];
    }

    return value.split('-').reverse().join('/');
});

Vue.filter('htmlEntities', function(value) {
    if (!value) return '';

    var txt = document.createElement("textarea");
    txt.innerHTML = value;
    return txt.value;
});

Vue.filter('trimText', function(text, maxChars, ending) {
    if (!text) return '';
    if (text.length <= maxChars ) return text;

    ending = ending || '...';
    return text.substring(0, maxChars) + ending;
});

Vue.filter('categoryLabel', function(categories, separator = ', ') {
    if (typeof(categories) === 'string') {
        return categories;
    }

    if (!categories || !categories.length) {
        return '';
    }

    let categoryLabel = categories.reduce(function(prev, curr, index) {
        return prev += separator + curr.name;
    }, '');

    return categoryLabel.slice(categoryLabel.indexOf(separator) + 2);
});